import { cn } from "../../lib/utils";
import React from "react";

const Badge = (props: { children: React.ReactNode; className?: string }) => {
  return (
    <div
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-foreground text-nowrap",
        props.className,
      )}
    >
      {props.children}
    </div>
  );
};
export default Badge;
